document.addEventListener("Searchanise.Loaded", function () {
  (function ($) {
    var snizeImagesBySrc = [];
    
    function snizeAddAltAttrToImages(productEl) {
      var snizeProductImages = productEl.find('.snize-item-image');
      
      if (snizeProductImages.length) {

        snizeProductImages.each(function(key, image) {
          snizeImagesBySrc[$(image).attr('src').replace('_large.', '.')] = image;
        });
        
        var productData = productEl.data("snize_item_data");
        var productHandle = Searchanise.ExtractProductHandle(productData.link);
        
        $.get("/products/" + productHandle + ".xml").done(function (product_data) {
          
          $(product_data).find('images image').each(function(key, image) {
            var src = $(image).find('src');
            var alt = $(image).find('alt');
            
            if (src.length && alt.length && snizeImagesBySrc[src.text()]) {
              $(snizeImagesBySrc[src.text()]).attr('alt', alt.text());
            }
          });
          
        });
      }
    }

    $(document).on("Searchanise.ResultsUpdated", function () {
      $('.snize-search-results .snize-product span.snize-title').each(function() {
        var html = $(this).prop('outerHTML');
        $(this).replaceWith('<h2 ' + html.substring(5, html.length - 7) + '</h2>');
      });
      
      $(".snize-search-results .snize-product").each(function () {
        snizeAddAltAttrToImages($(this));
      });
    });

    $(document).on("Searchanise.RecommendationUpdated", function () {
      $(".searchanise-recommendations .snize-product").each(function () {
        snizeAddAltAttrToImages($(this));
      });
    });
  })(window.Searchanise.$);
});